var map = {
	"./Argentina.png": "d6ba",
	"./Australia.png": "c86d",
	"./Austria.png": "619d",
	"./Bangladesh.png": "4fce",
	"./Belgium.png": "d042",
	"./Brazil.png": "68ab",
	"./Canada.png": "ac3c",
	"./Chile.png": "12f9",
	"./China.png": "807d",
	"./Colombia.png": "ea3a",
	"./Croatia.png": "7cdc",
	"./CzechRepublic.png": "f8ab",
	"./Denmark.png": "3d01",
	"./Ecuador.png": "e0a9",
	"./Egypt.png": "764c",
	"./Finland.png": "57fe",
	"./France.png": "89d5",
	"./Germany.png": "5ab5",
	"./Greece.png": "5bed",
	"./HongKong.png": "a1da",
	"./Hungary.png": "4f3a",
	"./India.png": "4e54",
	"./Indonesia.png": "0a33",
	"./Ireland.png": "4cf5",
	"./Israel.png": "9f89",
	"./Italy.png": "abe9",
	"./Japan.png": "ae21",
	"./Kenya.png": "12c6",
	"./Korea.png": "f88f",
	"./Lebanon.png": "cf23",
	"./Malaysia.png": "9450",
	"./Mexico.png": "ffb6",
	"./Morocco.png": "478f",
	"./Nepal.png": "a59b",
	"./Netherlands.png": "1306",
	"./NewZealand.png": "9049",
	"./Norway.png": "aced",
	"./Pakistan.png": "51e1",
	"./Peru.png": "34df",
	"./Philippines.png": "29af",
	"./Poland.png": "2b95",
	"./Portugal.png": "2bad",
	"./PuertoRico.png": "1b51",
	"./Qatar.png": "f451",
	"./Romania.png": "9a93",
	"./Russia.png": "8bd9",
	"./SaudiArabia.png": "2ea7",
	"./Serbia.png": "0e97",
	"./Singapore.png": "0ad4",
	"./Slovakia.png": "cb5b",
	"./Slovenia.png": "f76b",
	"./SouthAfrica.png": "d244",
	"./Spain.png": "e817",
	"./SriLanka.png": "8ebc",
	"./Sweden.png": "909b",
	"./Switzerland.png": "8a84",
	"./Taiwan.png": "1ed8",
	"./Thailand.png": "b934",
	"./Tunisia.png": "c76f",
	"./Turkey.png": "618b",
	"./UAE.png": "f1c6",
	"./UK-London.png": "ca0c",
	"./UK-North.png": "4b55",
	"./UK-Scotland.png": "0c64",
	"./UK.png": "97df",
	"./USA-Miami.png": "2563",
	"./USA.png": "07bf",
	"./Ukraine.png": "1023",
	"./Uruguay.png": "2e91",
	"./Venezuela.png": "0cee",
	"./Vietnam.png": "fb46"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "61f4";